import { ColorModeScript } from '@chakra-ui/react';
import React, {} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { ChakraProvider, extendTheme ,} from '@chakra-ui/react';
import { createBreakpoints } from "@chakra-ui/theme-tools"


const breakpoints = createBreakpoints({
  XS:"320px",
  S:"480px",
  M:"600px",
  L:"768px",
  XL:"900px",
  XXL:"1024px",
  XXXL:"1200px",
  XXXXL:"1400px"
})


const config = {
  initialColorMode: "light",
  useSystemColorMode: true,
}


const theme = extendTheme({ config , breakpoints })
ReactDOM.render(
  <>
    <ChakraProvider theme={theme}>
    <ColorModeScript />
    <App />
    </ChakraProvider>
  </>,
  document.getElementById('root')
);


